module.exports = __webpack_public_path__ + "static/media/0028_IMG_L_ESPACE_RESTAURATION_MAIL.4a7ef8cc.webp";